import { createStyles, Title, Text } from "@mantine/core";
import Reveal from "../Reveal";

const useStyles = createStyles((theme, { align, size, compact }) => ({
  root: {
    marginBottom: compact
      ? theme.spacing.md
      : size === "lg"
        ? theme.spacing.xl
        : theme.spacing.lg,
    textAlign: align,
  },
  title: {
    fontFamily: theme.headings?.fontFamily || '"Noto Serif TC", serif',
    color: theme.colors.gray[8],
    fontSize: size === "lg" ? "clamp(1.5rem, 2.8vw, 2rem)" : "clamp(1.2rem, 2vw, 1.5rem)",
    fontWeight: 600,
    letterSpacing: "0.04em",
    lineHeight: 1.3,
  },
  subtitle: {
    marginTop: theme.spacing.sm,
    maxWidth: align === "center" ? 640 : "none",
    marginLeft: align === "center" ? "auto" : undefined,
    marginRight: align === "center" ? "auto" : undefined,
    color: theme.colors.gray[6],
    fontSize: theme.fontSizes.md,
    lineHeight: 1.75,
    letterSpacing: "0.02em",
  },
  rule: {
    marginTop: compact ? theme.spacing.sm : theme.spacing.md,
    height: 2,
    width: align === "center" ? 48 : 40,
    marginLeft: align === "center" ? "auto" : 0,
    marginRight: align === "center" ? "auto" : undefined,
    backgroundColor: theme.colors.orange[4],
  },
}));

export default function SectionHeader({
  title,
  subtitle,
  order = 2,
  align = "center",
  size = "lg",
  id,
  showRule = true,
  animate = false,
  compact = false,
}) {
  const { classes } = useStyles({ align, size, compact });

  const header = (
    <header className={classes.root}>
      <Title order={order} id={id} className={classes.title}>
        {title}
      </Title>
      {subtitle && <Text className={classes.subtitle}>{subtitle}</Text>}
      {showRule && <div className={classes.rule} aria-hidden />}
    </header>
  );

  return animate ? <Reveal>{header}</Reveal> : header;
}
